import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { PrivacyEducationArticle } from '../../../../common/models/privacy/PrivacyEducationArticle.model';
import { ConnectDataPrivacyService } from '../../../../common/services/requests/connect-data-privacy/connect-data-privacy.service';
import { PrivacyService } from '../../../../common/services/process/privacy/privacy.service';
import { ValuesService } from '../../../../common/values/values.service';
import { LanguageService } from '../../../../common/services/core/language.service';
import { PrivacyValuesService } from '../../../../common/values/privacy.values.service';
import { OutletsStatusService, Outlet, OutletStatus } from '../../../../common/services/core/outlets.status.service';
import { QueryParamsService } from '../../../../common/services/core/query.params.service';

@Component({
    selector: 'app-privacy-education-article',
    templateUrl: './privacy-education-article.component.html',
    styleUrls: ['./../privacy-education.component.scss'],
    host: {
        '[class.dashboard-body]': 'true'
    }
})
export class PrivacyEducationArticleComponent implements OnInit, OnDestroy, AfterViewInit {

    private readonly onDestroy$: Subject<void> = new Subject<void>();

    public article: PrivacyEducationArticle;
    public errorState = false;
    private qp: any;

    constructor(
        private readonly connectDataPrivacyService: ConnectDataPrivacyService,
        private readonly route: ActivatedRoute,
        private readonly privacyService: PrivacyService,
        private readonly translateService: TranslateService,
        private readonly valuesService: ValuesService,
        private readonly router: Router,
        private readonly languageService: LanguageService,
        private readonly outletsStatusService: OutletsStatusService,
        public readonly privacyValuesService: PrivacyValuesService,
        private readonly queryParamsService: QueryParamsService
    ) { }

    ngOnInit(): void {
        this.qp = this.queryParamsService.getAll();
        this.translateService.onLangChange
        .pipe(takeUntil(this.onDestroy$))
        .subscribe( () => {
            this.start();
        });
        this.start();
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    ngAfterViewInit(): void {
        this.outletsStatusService.setStatus(Outlet.PAGE, OutletStatus.DONE);
    }

    //Entry point method
    private start(): void {
        this.connectDataPrivacyService.getEducationArticles([this.route.snapshot.paramMap.get('articleID')], this.languageService.getLang())
            .pipe(takeUntil(this.onDestroy$))
            .subscribe({
                next: res => {
                    if (!res || res.length === 0) {
                        this.errorState = true;
                        return;
                    }
                    this.article = res[0];
                },
                error: err => {
                    if (!this.privacyService.checkParkedIdentity(err, false)) {
                        this.errorState = true;
                    }
                }
            });
    }

    /**
     * Method that navigates back to news page
     * @returns {void}
     */
    public navigateToEducation(): void {
        this.router.navigate([this.valuesService.centralPaths.privacy.path.concat(this.valuesService.centralPaths.privacy.education.path)]);
    }

    // check the previous route and navigate to it
    public goBack(): void {
        if (this.qp && this.qp.pv && this.qp.pv === 'act') {
            this.queryParamsService.remove(['pv']);
            this.router.navigate([this.valuesService.centralPaths.privacy.path.concat(this.valuesService.centralPaths.privacy.activity.path)]);
        } else {
            this.router.navigate([this.valuesService.centralPaths.privacy.path.concat(this.valuesService.centralPaths.privacy.education.path)]);
        }
    }
}
